<template>
    <el-dialog
        class="edit"
        :visible.sync="editVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="1200px"
        title="编辑物品"
    >
        <el-form
            ref="editForm"
            :rules="rules"
            :model="editForm"
            label-width="100px"
        >
            <el-row>
                <el-col :span="12">
                    <el-form-item label="物品名称" prop="name" size="small">
                        <el-input
                            clearable
                            placeholder="请输入物品名称"
                            size="small"
                            v-model="editForm.name"
                        >
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="购买数量" prop="qty" size="small">
                        <el-input
                            clearable
                            placeholder="请输入购买数量"
                            size="small"
                            v-model="editForm.qty"
                            onkeyup="value=value.replace(/[^\d]/g,'')"
                        >
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="购买金额" prop="price" size="small">
                        <el-input
                            clearable
                            placeholder="请输入购买金额"
                            size="small"
                            v-model="editForm.price"
                        >
                            <!-- onkeyup="value=value.replace(/[^\d]/g,'')" -->
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item
                        label="购买时间"
                        size="small"
                        prop="purchase_time"
                    >
                        <el-date-picker
                            v-model="editForm.purchase_time"
                            type="date"
                            placeholder="请选择购买时间"
                            value-format="yyyy-MM-dd"
                            format="yyyy-MM-dd"
                            size="small"
                        >
                        </el-date-picker>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="单位" size="small" prop="unit">
                        <el-input
                            clearable
                            placeholder="请输入单位"
                            size="small"
                            v-model="editForm.unit"
                        >
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item
                        label="使用部门"
                        size="small"
                        prop="depart_list"
                    >
                        <!-- <selectbutton
                            :props="props"
                            :options="optionData"
                            :value="editForm.depart_id"
                            :clearable="isClearable"
                            :accordion="isAccordion"
                            @getValue="getValue($event)"
                            height="200"
                            ref="selectBtn"
                            placeholder="请选择使用部门"
                        ></selectbutton> -->
                        <el-cascader
                            clearable
                            :options="departList"
                            :props="props"
                            v-model="editForm.depart_list"
                            style="width:100%"
                            placeholder="请选择所在部门"
                            @change="departChange"
                        >
                        </el-cascader>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="状态" size="small" prop="status">
                        <el-select
                            v-model="editForm.status"
                            filterable
                            size="small"
                            placeholder="请选择状态"
                            @change="statusChange"
                        >
                            <el-option
                                v-for="item in statusList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="使用员工" size="small" prop="user_id">
                        <el-select
                            v-model="editForm.user_id"
                            filterable
                            size="small"
                            placeholder="请选择使用员工"
                            clearable
                        >
                            <el-option
                                v-for="item in departSelectUser"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item label="物品详情" size="small">
                        <el-input
                            clearable
                            placeholder="请输入物品详情"
                            size="small"
                            type="textarea"
                            rows="4"
                            v-model.number="editForm.desc"
                        >
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" type="primary" @click="save"
                >保存</el-button
            >
            <el-button size="small" @click="editVisible = false"
                >关闭</el-button
            >
        </span>
    </el-dialog>
</template>
<script>
import * as api from "@/http/api.js";
import * as oaApi from "@/http/oaApi.js";
import selectbutton from "@/comon/components/selectbutton";
import { mapState, mapMutations, mapActions } from "vuex";
export default {
    data() {
        var two = /^-?\d+(\.\d{1,2})?$/;
        var validatePrice = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请输入购买金额"));
            } else {
                if (value == 0) {
                    callback(new Error("购买金额不能为0"));
                } else if (!two.test(value)) {
                    // callback(new Error("不能超过小数点后两位"));
                    setTimeout(() => {
                        let index = 0;
                        index = this.editForm.price.indexOf(".");
                        this.editForm.price = this.editForm.price.slice(
                            0,
                            index + 3
                        );
                    });
                }
                callback();
            }
        };
        var validateQty = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请输入购买数量"));
            } else {
                if (value == 0) {
                    callback(new Error("购买数量不能为0"));
                }
                callback();
            }
        };
        return {
            editForm: {
                depart_list: "",
                user_id: "",
                purchase_time: "",
                name: "",
                unit: "",
                qty: 1,
                desc: "",
                price: "",
                status: 1
            },
            rules: {
                name: [{ required: true, message: "请输入物品名称" }],
                qty: [
                    { required: true, validator: validateQty, trigger: "blur" }
                ],
                price: [
                    {
                        required: true,
                        validator: validatePrice,
                        trigger: "blur"
                    }
                ],
                purchase_time: [
                    {
                        required: true,
                        message: "请选择购买时间",
                        trigger: "change"
                    }
                ],
                unit: [{ required: true, message: "请输入单位" }],
                depart_list: [{ required: true, message: "请选择使用部门" }],
                user_id: [{ required: true, message: "请选择使用员工" }],
                status: [{ required: true, message: "请选择状态" }]
            },
            isClearable: true, // 可清空（可选）
            isAccordion: true, // 可收起（可选）
            valueId: "", // 初始ID（可选）
            props: {
                // 配置项（必选）
                value: "id",
                label: "name",
                children: "child"
                // disabled: true
            },
            // 选项列表（必选）
            departList: [],
            props: {
                value: "id",
                label: "name",
                children: "child",
                checkStrictly: true
            },
            statusList: [
                { name: "未使用", id: 2 },
                { name: "使用中", id: 1 },
                { name: "报废", id: 3 },
                { name: "备用", id: 4 }
            ]
        };
    },
    methods: {
        ...mapActions(["getDepartSelectUser"]),
        ...mapMutations(["DEPART_SELECT_USER"]),
        /**
         * 新增窗口关闭
         */
        closeDialog() {
            this.editForm = {
                depart_list: "",
                user_id: "",
                purchase_time: "",
                name: "",
                unit: "",
                qty: 1,
                desc: "",
                price: "",
                status: 1
            };
            this.$refs["editForm"].clearValidate();
            this.$refs["editForm"].resetFields();
            this.$emit("update:editVisible", false);
            // 清空使用员工
            this.DEPART_SELECT_USER([]);
        },
        /**
         *  保存
         */
        save() {
            this.$refs["editForm"].validate(valid => {
                if (valid) {
                    oaApi
                        .commodity(
                            { ...this.editForm },
                            "put",
                            this.tableItem.id
                        )
                        .then(res => {
                            if (res) {
                                if (res.code == 200) {
                                    this.$message.success("编辑成功");
                                    this.$parent.commodity();
                                }
                                this.closeDialog();
                            }
                        });
                }
            });
        },
        // 取值
        getValue(value) {
            if(value){
                this.editForm.depart_id = value.id;
                this.editForm.user_id = "";
            }else{
                this.editForm.depart_id = "";
            }
        },
        /**
         *  获取组织架构信息
         */
        depart() {
            api.depart({}, "get").then(res => {
                if (res) {
                    this.departList = res.data;
                }
            });
        },
        commodity() {
            oaApi.commodity({}, "get", this.tableItem.id).then(res => {
                if (res) {
                    this.editForm = res.data;
                    res.data.depart_list.length>0 &&
                        this.getDepartSelectUser({
                            depart_list: res.data.depart_list
                        });
                    this.statusChange(res.data.status);
                }
            });
        },
        statusChange(val) {
            // 未使用
            if (val == 4) {
                this.$set(this.rules.depart_list[0], "required", false);
                this.$set(this.rules.user_id[0], "required", false);
            } else {
                this.$set(this.rules.depart_list[0], "required", true);
                this.$set(this.rules.user_id[0], "required", true);
            }
        },
        departChange(val) {
            // console.log(val);
            // 清空使用员工
            this.DEPART_SELECT_USER([]);
            val.length>0 && this.getDepartSelectUser({ depart_list: val });
            this.editForm.user_id = "";
        }
    },
    props: {
        editVisible: Boolean,
        tableItem: Object
    },
    components: {
        selectbutton: selectbutton
    },
    computed: {
        /* 转树形数据 */
        optionData() {
            let cloneData = JSON.parse(JSON.stringify(this.list)); // 对源数据深度克隆
            return cloneData.filter(father => {
                // 循环所有项，并添加children属性
                let branchArr = cloneData.filter(
                    child => father.id == child.parent_id
                ); // 返回每一项的子级数组
                branchArr.length > 0 ? (father.child = branchArr) : ""; //给父级添加一个children属性，并赋值
                return father.parent_id == 0; //返回第一层
            });
        },
        ...mapState({
            departSelectUser: state => state.index.departSelectUser
        }),
        mixed() {
            const { tableItem, editVisible } = this;
            return {
                tableItem,
                editVisible
            };
        }
    },
    watch: {
        mixed: {
            handler(newValue) {
                if (newValue.editVisible) {
                    this.depart();
                    this.tableItem = newValue.tableItem;
                    this.commodity();
                }
            },
            immediate: false,
            deep: true
        }
    }
};
</script>
<style lang="scss">
.edit {
    .el-form-item__content {
        .el-select,
        .el-select--small,
        .el-date-editor {
            width: 100%;
        }
        .is-disabled {
            .el-input__inner {
                color: #606266;
            }
        }
    }
}
</style>
